import { DismissedConflictsStore } from "sh-conflict-store";
import { IConflictDismissEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('ADD_DISMISSED_CONFLICT_ENTITY', function addDismissedConflictEntity(conflictDismissEntity: IConflictDismissEntity) {
    if (conflictDismissEntity) {
        DismissedConflictsStore().entityIdToDismissedConflictEntities.set(conflictDismissEntity.id, conflictDismissEntity);
    }
});
